import { extend, configure } from 'vee-validate';
import { required, email, confirmed } from 'vee-validate/dist/rules';
import { i18n } from "./i18n";

// localize({
//   messages: {
//     en: {
//       fields: {
//         email: 'E-mail Address',
//         password: 'Password'
//       }
//     },
//     pt: {
//       fields: {
//         email: 'E-mail',
//         password: 'Senha'
//       }
//     }
//   }
// })

configure({
  defaultMessage: (field, values) => {
    // override the field name.
    values._field_ = i18n.t(`fields.${field}`)
    return i18n.t(`validation.${values._rule_}`, values)
  }
});

// Install required rule and message.
extend("required", required)
// Install email rule and message.
extend("email", email)
// Install confirmed rule and message.
extend("confirmed", confirmed)
// Install valid URL rules
extend('url', {
  validate: (str) => {
      var pattern = new RegExp('^(https?:\\/\\/)?'+ // protocol
          '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|'+ // domain name
          '((\\d{1,3}\\.){3}\\d{1,3}))'+ // OR ip (v4) address
          '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*'+ // port and path
          '(\\?[;&a-z\\d%_.~+=-]*)?'+ // query string
          '(\\#[-a-z\\d_]*)?$','i'); // fragment locator
      return !!pattern.test(str);
  },
  //message: 'This is not a valid URL'
})
// Mac adress Rule
extend('macaddress', {
  validate: (str) => {
      var pattern = new RegExp('^((([a-fA-F0-9][a-fA-F0-9]+[-]){5}|([a-fA-F0-9][a-fA-F0-9]+[:]){5})([a-fA-F0-9][a-fA-F0-9])$)|(^([a-fA-F0-9][a-fA-F0-9][a-fA-F0-9][a-fA-F0-9]+[.]){2}([a-fA-F0-9][a-fA-F0-9][a-fA-F0-9][a-fA-F0-9]))$'); 
      return !!pattern.test(str);
  },
  //message: 'This is not a valid URL'
})
